import { usePage } from '../../contexts'
import { IVodPost } from '../../types'
import { Image } from '../Image/Image'
import Link from '../Link/Link'
import { utils } from '../Player/Helpers/utils'
import { Shave } from '../Shave/Shave'
import {
  AirDate,
  Container,
  Overlay,
  TextContainer,
  Thumbnail,
  Title,
} from './VodPost.styles'
import PlayButton from '/public/assets/images/svg/play-button.svg'

type Props = {
  post: IVodPost
}

export const VodPost = ({ post }: Props) => {
  const {
    isBlank,
    id,
    link: postLink,
    background,
    imageObj,
    title,
    video,
    air_date,
    airDate: postAirDate,
  } = post
  const linkTarget = isBlank ? '_blank' : undefined
  const pageId = usePage()?.PageMeta.id

  const link = utils.addPageQueryParams(postLink, pageId, id)
  const airDate = (air_date || postAirDate)?.split('/').join('.')

  return (
    <Container backgroundColor={background}>
      <Thumbnail href={link} target={linkTarget}>
        <Image image={imageObj} alt={title} />
        <Overlay />
        {video && <PlayButton />}
      </Thumbnail>
      <TextContainer>
        <Link href={link} target={linkTarget}>
          <Shave maxLines={3}>
            <Title>{title}</Title>
          </Shave>
        </Link>
        <AirDate>{airDate}</AirDate>
      </TextContainer>
    </Container>
  )
}
